import { createAppCustomCssApi } from './custom-css/index';
import { createAppCustomJsApi } from './custom-js/index';
export var createAppSettingsApi = function (baseUrl, http) {
    var appApiUrl = "".concat(baseUrl, "/app");
    return {
        customJs: createAppCustomJsApi(appApiUrl, http),
        customCss: createAppCustomCssApi(appApiUrl, http)
    };
};
//# sourceMappingURL=index.js.map